import { render } from "./list-comments.vue?vue&type=template&id=cd54a51c&ts=true"
import script from "./list-comments.vue?vue&type=script&lang=ts"
export * from "./list-comments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__